import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import ScrollToTop from './components/ScrollToTop';

// Import components
import NavigationBar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Doctors from './components/Doctors';
import Partners from './components/Partners';
import RecoveryPrograms from './components/RecoveryPrograms';
import Locations from './components/Locations';
import Careers from './components/Careers';
import AboutUs from './components/AboutUs';
import ContactUs from './components/ContactUs';
import Equipment from './components/Equipment';
import Footer from './components/Footer';
import LocalSEO from './components/LocalSEO';
import SEO from './components/SEO';

// Service Pages
import Physiotherapy from './components/services/Physiotherapy';
import NursingCare from './components/services/NursingCare';
import DoctorConsultation from './components/services/DoctorConsultation';
import LabTests from './components/services/LabTests';
import CareGiver from './components/services/CareGiver';
import MotherBabyCare from './components/services/MotherBabyCare';
import ICUAtHome from './components/services/ICUAtHome';
import NursingAttendant from './components/services/NursingAttendant';
import IVIMInjection from './components/services/IVIMInjection';
import ParkinsonsCare from './components/services/ParkinsonsCare';

// Home page component that contains all sections
const Home = () => {
  return (
    <>
      <SEO 
        title="Home Healthcare Services in Bangalore"
        description="Caremetto Healthcare provides trusted home healthcare services in Bangalore including nursing care, physiotherapy, doctor consultations, and specialized medical services at your doorstep."
        keywords="home healthcare Bangalore, nursing care Bangalore, physiotherapy at home, doctor consultation, elderly care services, medical services at home"
      />
      <Hero />
      <Services />
      {/* <Doctors /> */}
      {/* <RecoveryPrograms /> */}
      <Partners />
      <LocalSEO />
      {/* <Locations /> */}
    </>
  );
};

// AnimatedRoutes component to handle transitions
const AnimatedRoutes = () => {
  const location = useLocation();
  const nodeRef = React.useRef(null);
  
  return (
    <TransitionGroup>
      <CSSTransition
        nodeRef={nodeRef}
        key={location.key}
        timeout={300}
        classNames="fade"
      >
        <div ref={nodeRef}>
          <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/equipment" element={<Equipment />} />
          <Route path="/career" element={<Careers />} />
          <Route path="/contact" element={<ContactUs />} />
          
          {/* Service Pages Routes */}
          <Route path="/services/physiotherapy" element={<Physiotherapy />} />
          <Route path="/services/nursing-care" element={<NursingCare />} />
          <Route path="/services/doctor-consultation" element={<DoctorConsultation />} />
          <Route path="/services/lab-tests" element={<LabTests />} />
          <Route path="/services/care-giver" element={<CareGiver />} />
          <Route path="/services/mother-baby-care" element={<MotherBabyCare />} />
          <Route path="/services/icu-at-home" element={<ICUAtHome />} />
          <Route path="/services/nursing-attendants" element={<NursingAttendant />} />
          <Route path="/services/iv-injection" element={<IVIMInjection />} />
          <Route path="/services/parkinsons-care" element={<ParkinsonsCare />} />
        </Routes>
        </div>
      </CSSTransition>
    </TransitionGroup>
  );
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <NavigationBar />
        <AnimatedRoutes />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
